import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { createContext, useContext } from 'react';
import type { DeviceInfo } from '@/idv2/hooks';
import MissingPermissionsSheet from './missing-permissions-sheet';
import useLocalSheet from './use-local-sheet';
export type MissingPermissionsSheetProviderProps = {
  device: DeviceInfo;
  children: React.ReactNode;
};
type LocalSheetContextValue = ReturnType<typeof useLocalSheet>;
const LocalSheetContext = createContext<LocalSheetContextValue | null>(null);
const useLocalSheetContext = () => {
  const context = useContext(LocalSheetContext);
  if (!context) {
    throw new Error("useLocalSheetContext must be used within LocalSheetProvider");
  }
  return context;
};
const LocalSheetProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const value = useLocalSheet();
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <LocalSheetContext.Provider value={value}>{children}</LocalSheetContext.Provider>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const SheetManager = t0 => {
  const $ = _c(6);
  const {
    device
  } = t0;
  const {
    sheet,
    hide
  } = useLocalSheetContext();
  let t1;
  if ($[0] !== hide) {
    t1 = onClose => () => {
      hide();
      onClose?.();
    };
    $[0] = hide;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClose = t1;
  let t2;
  if ($[2] !== device || $[3] !== handleClose || $[4] !== sheet) {
    t2 = sheet ? <MissingPermissionsSheet device={device} open={sheet.open} onClose={handleClose(sheet.onClose)} /> : null;
    $[2] = device;
    $[3] = handleClose;
    $[4] = sheet;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
const MissingPermissionsSheetProvider = t0 => {
  const $ = _c(5);
  const {
    device,
    children
  } = t0;
  let t1;
  if ($[0] !== device) {
    t1 = <SheetManager device={device} />;
    $[0] = device;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <LocalSheetProvider>{t1}{children}</LocalSheetProvider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const useMissingPermissionsSheet = () => {
  const $ = _c(3);
  const sheet = useLocalSheetContext();
  let t0;
  if ($[0] !== sheet.hide || $[1] !== sheet.show) {
    t0 = {
      hide: sheet.hide,
      show: sheet.show
    };
    $[0] = sheet.hide;
    $[1] = sheet.show;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default MissingPermissionsSheetProvider;